import { mergeStyleSets } from '@uifabric/merge-styles';
import { layout } from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    paddingTop: '2rem',
    selectors: {
      [layout.breakpoints.min.md]: {
        paddingTop: '3rem',
      },
    },
  },
  iframeContainer: {
    position: 'relative',
    overflow: 'hidden',
    paddingTop: '56.25%',
  },
  iframe: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
  pbiCanvas: {
    padding: '0 1rem 2rem',
    selectors: {
      [layout.breakpoints.min.lg]: {
        paddingLeft: '2rem',
        paddingRight: '2rem',
      },
    },
  },
  searchBar: {
    marginLeft: '2rem',
    marginBottom: pxToRem(30),
  },
});
